function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "13",
  viewBox: "0 0 17 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v13h10V0H0zm2.955 11.325H1.378V9.749h1.579v1.576h-.002zm0-2.741H1.378V7.009h1.579v1.575h-.002zm0-2.74H1.378V4.267h1.579v1.575h-.002zm0-2.742H1.378V1.527h1.579v1.575h-.002zm2.804 8.223H4.182V9.749H5.76v1.576H5.76zm0-2.741H4.182V7.009H5.76v1.575H5.76zm0-2.74H4.182V4.267H5.76v1.575H5.76zm0-2.742H4.182V1.527H5.76v1.575H5.76zm2.805 8.223H6.986V9.749h1.578v1.576zm0-2.741H6.986V7.009h1.578v1.575zm0-2.74H6.986V4.267h1.578v1.575zm0-2.742H6.986V1.527h1.578v1.575z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3v10h7V3h-7zm2.929 8.307h-1.564v-1.59h1.564v1.59zm0-2.769h-1.564v-1.59h1.564v1.59zm0-2.769h-1.564V4.18h1.564v1.59zm2.776 5.538h-1.563v-1.59h1.563v1.59zm0-2.769h-1.563v-1.59h1.563v1.59zm0-2.769h-1.563V4.18h1.563v1.59z",
  fill: "#000"
})));